import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';
import { UpdateUserMembershipDto, UserMembershipDto } from '../../../models/user-membership/dto/user-membership.dto';
import { GET_USER_MEMBERSHIPS_QUERY_KEY } from './useGetUserMemberships';

export const useUpdateUserMembership = (membershipId: string) => {
    const apiClient = useApiClient();
    const queryClient = useQueryClient();
    return useMutation({
        mutationKey: ['updateUserMembership', membershipId],
        mutationFn: async (body: UpdateUserMembershipDto) => {
            const response = await apiClient.fetchApi<UserMembershipDto, UpdateUserMembershipDto>({ method: 'PUT', endpoint: `user-memberships/${membershipId}`, body });
            return response
        },
        onSuccess: (data: UserMembershipDto, variables: UpdateUserMembershipDto) => {
            queryClient.setQueryData<UserMembershipDto[]>(GET_USER_MEMBERSHIPS_QUERY_KEY(data.userId), (previousData) => {
                return [...(previousData || []).filter(item => item.id !== membershipId), data];
            });
        }
    });
};